export default __webpack_public_path__ + "static/taskdeploy2-37e07c908e85d09bfd9869937261cc47.png";